module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "FMBM-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface"
    }
  }, [_vm._v("PREFACE: "), _c('b', [_vm._v("Organic Awareness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("INTRODUCTION: "), _c('b', [_vm._v("Embrace Home-Cooked Food")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head"
  }, [_c('a', {
    attrs: {
      "href": "#/Part1#P1"
    }
  }, [_c('b', [_vm._v("PART 1: READY, SET, PREP")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("CHAPTER 1: "), _c('b', [_vm._v("Organics Boot Camp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter2#C2"
    }
  }, [_vm._v("CHAPTER 2: "), _c('b', [_vm._v("Meal Planning and Preparation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3: "), _c('b', [_vm._v("Kitchen and Pantry Essentials")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head"
  }, [_c('span', {
    attrs: {
      "href": "#/Part2#P2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART 2: THE RECIPES: ORGANIC MEALS FOR GROWING APPETITES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4: "), _c('b', [_vm._v("The Transitioner—9 to 12 Months")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter41#C4-1"
    }
  }, [_vm._v("Banana Cinnamon Oatmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter42#C4-2"
    }
  }, [_vm._v("Just Peachy Oatmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter43#C4-3"
    }
  }, [_vm._v("Seasoned Hard-Boiled Eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter44#C4-4"
    }
  }, [_vm._v("Cinnamon French Toast Sticks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter45#C4-5"
    }
  }, [_vm._v("Blooming Popovers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter46#C4-6"
    }
  }, [_vm._v("Blueberry Mango Cereal Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter47#C4-7"
    }
  }, [_vm._v("Smoky Collard Mash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter48#C4-8"
    }
  }, [_vm._v("Savory Cornbread Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter49#C4-9"
    }
  }, [_vm._v("Creamed Spinach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter410#C4-10"
    }
  }, [_vm._v("Sweet Potato Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter411#C4-11"
    }
  }, [_vm._v("Baby Shawarma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter412#C4-12"
    }
  }, [_vm._v("Baked Chicken Drumsticks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter413#C4-13"
    }
  }, [_vm._v("Leftover Rotisserie Chicken Stock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter414#C4-14"
    }
  }, [_vm._v("Vegetable Stock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter415#C4-15"
    }
  }, [_vm._v("Too Good Tomato Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter416#C4-16"
    }
  }, [_vm._v("Super Egg Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter417#C4-17"
    }
  }, [_vm._v("Crunchy Green Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter418#C4-18"
    }
  }, [_vm._v("Grilled Cheese Squares")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter419#C4-19"
    }
  }, [_vm._v("My First Fruit Salad with Yogurt Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter420#C4-20"
    }
  }, [_vm._v("Peach Applesauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter421#C4-21"
    }
  }, [_vm._v("Chunky Cherry Applesauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter422#C4-22"
    }
  }, [_vm._v("Kale Toscana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter423#C4-23"
    }
  }, [_vm._v("Orzo Harmony")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter424#C4-24"
    }
  }, [_vm._v("Rigatoni Marinara")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter425#C4-25"
    }
  }, [_vm._v("Pimento Mac and Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter426#C4-26"
    }
  }, [_vm._v("Marinara Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter427#C4-27"
    }
  }, [_vm._v("Timeless Minestrone Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter428#C4-28"
    }
  }, [_vm._v("South of the Border Taco Bowl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter429#C4-29"
    }
  }, [_vm._v("Chicken Corn Chowder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter430#C4-30"
    }
  }, [_vm._v("Cool Pasta Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter431#C4-31"
    }
  }, [_vm._v("Woodland Mushroom Risotto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter432#C4-32"
    }
  }, [_vm._v("Chilled White Grape Peach Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter433#C4-33"
    }
  }, [_vm._v("Simply Quinoa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter434#C4-34"
    }
  }, [_vm._v("Slow Cooker Baby Lima Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter435#C4-35"
    }
  }, [_vm._v("Sautéed Kale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter436#C4-36"
    }
  }, [_vm._v("All-American Burger Dogs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter437#C4-37"
    }
  }, [_vm._v("Stuffed Cabbage with Gravy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter438#C4-38"
    }
  }, [_vm._v("Skillet Apples")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter439#C4-39"
    }
  }, [_vm._v("Fruit Parfait")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5: "), _c('b', [_vm._v("The Explorer—12 to 18 Months")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter51#C5-1"
    }
  }, [_vm._v("Dutch Baked Apple Pancake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter52#C5-2"
    }
  }, [_vm._v("Fried Egg Sizzler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter53#C5-3"
    }
  }, [_vm._v("Butterscotch Oatmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter54#C5-4"
    }
  }, [_vm._v("Two-Berry Parfait")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter55#C5-5"
    }
  }, [_vm._v("Scrumptious Prune Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter56#C5-6"
    }
  }, [_vm._v("Fiesta Omelet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter57#C5-7"
    }
  }, [_vm._v("Hummus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter58#C5-8"
    }
  }, [_vm._v("Chilled Strawberry Refresher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter59#C5-9"
    }
  }, [_vm._v("Cheese Pizza-Dillas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter510#C5-10"
    }
  }, [_vm._v("Savory Herbed Chicken Breasts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter511#C5-11"
    }
  }, [_vm._v("Chicken and Sun-Dried Tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter512#C5-12"
    }
  }, [_vm._v("Tantalizing Tandoori Chicken Remix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter513#C5-13"
    }
  }, [_vm._v("Speedy Chicken Cordon Bleu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter514#C5-14"
    }
  }, [_vm._v("Crusty Smoky Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter515#C5-15"
    }
  }, [_vm._v("Homemade Bread Crumbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter516#C5-16"
    }
  }, [_vm._v("Mozzarella Sticks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter517#C5-17"
    }
  }, [_vm._v("Vegetable Couscous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter518#C5-18"
    }
  }, [_vm._v("Fruitty Tutti Take-Along Snack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter519#C5-19"
    }
  }, [_vm._v("Parmesan Chicken Skillet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter520#C5-20"
    }
  }, [_vm._v("Italian Herbed Spaghetti Squash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter521#C5-21"
    }
  }, [_vm._v("Orzo Pilaf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter522#C5-22"
    }
  }, [_vm._v("Italian Snow Peas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter523#C5-23"
    }
  }, [_vm._v("Kale Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter524#C5-24"
    }
  }, [_vm._v("Grape Streusel Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter525#C5-25"
    }
  }, [_vm._v("Triple-Berry Blastoff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter526#C5-26"
    }
  }, [_vm._v("Purple Cow on the Rocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter527#C5-27"
    }
  }, [_vm._v("American Dream Potato Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter528#C5-28"
    }
  }, [_vm._v("Double Melon Quencher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter529#C5-29"
    }
  }, [_vm._v("Cherry Potion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter530#C5-30"
    }
  }, [_vm._v("Pizza Burger Dogs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter531#C5-31"
    }
  }, [_vm._v("Berry Fruity Cobb Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter532#C5-32"
    }
  }, [_vm._v("Florida Orange Yogurt Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter533#C5-33"
    }
  }, [_vm._v("Pear Vinaigrette Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter534#C5-34"
    }
  }, [_vm._v("Chopped Strawberry Fields Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter535#C5-35"
    }
  }, [_vm._v("Surprise Chicken Nuggets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter536#C5-36"
    }
  }, [_vm._v("Raspberry Vinaigrette Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter537#C5-37"
    }
  }, [_vm._v("Peach Grape Crush")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter538#C5-38"
    }
  }, [_vm._v("Fruit-Infused Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter539#C5-39"
    }
  }, [_vm._v("Three-Bean Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter540#C5-40"
    }
  }, [_vm._v("Honey Mustard Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter541#C5-41"
    }
  }, [_vm._v("Smothered Asparagus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter542#C5-42"
    }
  }, [_vm._v("Coconut Teriyaki Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter543#C5-43"
    }
  }, [_vm._v("Tex-Mex Fried Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter544#C5-44"
    }
  }, [_vm._v("Tofu Avocado Spread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter545#C5-45"
    }
  }, [_vm._v("Ambrosia Yogurt Cup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter546#C5-46"
    }
  }, [_vm._v("Happy Birthday Melon “Cake”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter547#C5-47"
    }
  }, [_vm._v("Homemade Maple Whipped Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter548#C5-48"
    }
  }, [_vm._v("Frozen Raspberry Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6: "), _c('b', [_vm._v("The Picky Eater—18 to 24 Months")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter61#C6-1"
    }
  }, [_vm._v("Egg and Cheese Strata")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter62#C6-2"
    }
  }, [_vm._v("Black Bean Breakfast Burrito")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter63#C6-3"
    }
  }, [_vm._v("Homemade Toaster Pastries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter64#C6-4"
    }
  }, [_vm._v("Apple Orchard Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter65#C6-5"
    }
  }, [_vm._v("Belgian Waffle Wedges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter66#C6-6"
    }
  }, [_vm._v("Berrylicious Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter67#C6-7"
    }
  }, [_vm._v("Breakfast Crepes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter68#C6-8"
    }
  }, [_vm._v("Sautéed Cabbage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter69#C6-9"
    }
  }, [_vm._v("Apple Lemonade Sipper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter610#C6-10"
    }
  }, [_vm._v("Summer Turkey Tenderloin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter611#C6-11"
    }
  }, [_vm._v("Crispy Honey Chicken Nuggets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter612#C6-12"
    }
  }, [_vm._v("Grilled Turkey Sliders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter613#C6-13"
    }
  }, [_vm._v("Shrimp Linguine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter614#C6-14"
    }
  }, [_vm._v("Italian Sausage, Taters, and Ketchup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter615#C6-15"
    }
  }, [_vm._v("English Muffin Pepperoni Pizza")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter616#C6-16"
    }
  }, [_vm._v("Sloppy Joe Pasta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter617#C6-17"
    }
  }, [_vm._v("Nuts Be Gone Trail Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter618#C6-18"
    }
  }, [_vm._v("Cinnamon-Apple Pinwheels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter619#C6-19"
    }
  }, [_vm._v("Tofu Nuggets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter620#C6-20"
    }
  }, [_vm._v("Sweet Potato Cornbread Muffins with Maple Butter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter621#C6-21"
    }
  }, [_vm._v("Jumbo Stuffed Shells")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter622#C6-22"
    }
  }, [_vm._v("Lemon Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter623#C6-23"
    }
  }, [_vm._v("Orange Chicken Stir-Fry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter624#C6-24"
    }
  }, [_vm._v("Honey-Orange Carrot Jewels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter625#C6-25"
    }
  }, [_vm._v("Cheeseburger Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter626#C6-26"
    }
  }, [_vm._v("Smothered Tilapia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter627#C6-27"
    }
  }, [_vm._v("Strawberry and Banana Muesli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter628#C6-28"
    }
  }, [_vm._v("Holiday Turkey Breast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter629#C6-29"
    }
  }, [_vm._v("Spinach Pie in the Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter630#C6-30"
    }
  }, [_vm._v("Chunky Cucumber Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter631#C6-31"
    }
  }, [_vm._v("Magic Mango Coleslaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter632#C6-32"
    }
  }, [_vm._v("Cucumber Mint Lemonade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter633#C6-33"
    }
  }, [_vm._v("Quinoa Tabouli Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter634#C6-34"
    }
  }, [_vm._v("Traditional Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter635#C6-35"
    }
  }, [_vm._v("Sunflower Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter636#C6-36"
    }
  }, [_vm._v("Harvest Apple Risotto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter637#C6-37"
    }
  }, [_vm._v("Cauliflower Dressed in Orange")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter638#C6-38"
    }
  }, [_vm._v("Mango Pineapple Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter639#C6-39"
    }
  }, [_vm._v("Creamy Spinach Pita Pizza")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter640#C6-40"
    }
  }, [_vm._v("Chicken Enchiladas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter641#C6-41"
    }
  }, [_vm._v("Pimento Boats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter642#C6-42"
    }
  }, [_vm._v("Broccoli Parmesan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter643#C6-43"
    }
  }, [_vm._v("Caribbean Graham Snacks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter644#C6-44"
    }
  }, [_vm._v("Roasted Carrot Fries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter645#C6-45"
    }
  }, [_vm._v("Zucchini Ships")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter646#C6-46"
    }
  }, [_vm._v("Grilled Pineapple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter647#C6-47"
    }
  }, [_vm._v("Cilantro Lime Jasmine Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter648#C6-48"
    }
  }, [_vm._v("Zucchini Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter649#C6-49"
    }
  }, [_vm._v("Sautéed Garlic and Dill Green Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter650#C6-50"
    }
  }, [_vm._v("Pineapple Gone Green Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter651#C6-51"
    }
  }, [_vm._v("Raspberry Hot Chocolate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter652#C6-52"
    }
  }, [_vm._v("Luscious Citrus Melonade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter653#C6-53"
    }
  }, [_vm._v("Strawberry Cantaloupe Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter654#C6-54"
    }
  }, [_vm._v("Ginger Pear Crumble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter655#C6-55"
    }
  }, [_vm._v("Choco-Nana Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter656#C6-56"
    }
  }, [_vm._v("Cantaloupe Frozen Yogurt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7: "), _c('b', [_vm._v("The Independent Toddler—2 to 3 Years")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter71#C7-1"
    }
  }, [_vm._v("Cinnamon Granola Crunch Cereal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter72#C7-2"
    }
  }, [_vm._v("Cheddar Cheese Frittata")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter73#C7-3"
    }
  }, [_vm._v("Stuffed Strawberry French Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter74#C7-4"
    }
  }, [_vm._v("Best-Ever Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter75#C7-5"
    }
  }, [_vm._v("Spiced Peach Syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter76#C7-6"
    }
  }, [_vm._v("Blueberry Burst Syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter77#C7-7"
    }
  }, [_vm._v("Zesty Breakfast Wrap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter78#C7-8"
    }
  }, [_vm._v("Chicken Goulash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter79#C7-9"
    }
  }, [_vm._v("Veggie and Hummus Platter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter710#C7-10"
    }
  }, [_vm._v("Homemade Bruschetta Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter711#C7-11"
    }
  }, [_vm._v("Bruschetta Grilled Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter712#C7-12"
    }
  }, [_vm._v("Basic Pizza Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter713#C7-13"
    }
  }, [_vm._v("French Bread Cheese Pizza")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter714#C7-14"
    }
  }, [_vm._v("Garlic and Herb Corn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter715#C7-15"
    }
  }, [_vm._v("Southern Shrimp and Grits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter716#C7-16"
    }
  }, [_vm._v("Baby Cobb Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter717#C7-17"
    }
  }, [_vm._v("Honey Mustard Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter718#C7-18"
    }
  }, [_vm._v("Southwest Potato Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter719#C7-19"
    }
  }, [_vm._v("Garlic Ranch Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter720#C7-20"
    }
  }, [_vm._v("Banana Cream Cheese Pinwheels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter721#C7-21"
    }
  }, [_vm._v("Baked Teriyaki Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter722#C7-22"
    }
  }, [_vm._v("Super Crispy Chicken Fritters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter723#C7-23"
    }
  }, [_vm._v("Honey Teriyaki Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter724#C7-24"
    }
  }, [_vm._v("Cinnamon Watermelon Bowl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter725#C7-25"
    }
  }, [_vm._v("Citrus Ginger Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter726#C7-26"
    }
  }, [_vm._v("Big Kid Taco Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter727#C7-27"
    }
  }, [_vm._v("Steak Quesadillas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter728#C7-28"
    }
  }, [_vm._v("Homemade Guacamole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter729#C7-29"
    }
  }, [_vm._v("Hibachi Fried Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter730#C7-30"
    }
  }, [_vm._v("Traveling Bean and Bacon Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter731#C7-31"
    }
  }, [_vm._v("Creamy Coconut Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter732#C7-32"
    }
  }, [_vm._v("Aged Cheddar Cheese Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter733#C7-33"
    }
  }, [_vm._v("Vegetable Lasagna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter734#C7-34"
    }
  }, [_vm._v("Baked Coconut Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter735#C7-35"
    }
  }, [_vm._v("Turkey Roll-Ups")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter736#C7-36"
    }
  }, [_vm._v("Lemon Crunch Pasta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter737#C7-37"
    }
  }, [_vm._v("Pacific Cod Au Gratin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter738#C7-38"
    }
  }, [_vm._v("Baja Fish Tacos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter739#C7-39"
    }
  }, [_vm._v("Slow Cooker Flank Steak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter740#C7-40"
    }
  }, [_vm._v("Shepherd’s Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter741#C7-41"
    }
  }, [_vm._v("Creamy Dreamy Tortellini")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter742#C7-42"
    }
  }, [_vm._v("Grilled Chicken Brochettes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter743#C7-43"
    }
  }, [_vm._v("Brazilian Coconut Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter744#C7-44"
    }
  }, [_vm._v("Orzo with Tofu in a Creamy Tomato Spinach Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter745#C7-45"
    }
  }, [_vm._v("Barbecue Tofu and Quinoa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter746#C7-46"
    }
  }, [_vm._v("Stir-Fried Noodles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter747#C7-47"
    }
  }, [_vm._v("Cinnamon Pineapple Crumble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter748#C7-48"
    }
  }, [_vm._v("Chicken Wraps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter749#C7-49"
    }
  }, [_vm._v("BLTA Wrap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter750#C7-50"
    }
  }, [_vm._v("Mexican Burger Dogs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter751#C7-51"
    }
  }, [_vm._v("Monkey Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter752#C7-52"
    }
  }, [_vm._v("Strawberry Banana Surprise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter753#C7-53"
    }
  }, [_vm._v("Mango Raspberry Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter754#C7-54"
    }
  }, [_vm._v("Pineapple Peach Pick Me Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter755#C7-55"
    }
  }, [_vm._v("Cucumber Melon Zinger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter756#C7-56"
    }
  }, [_vm._v("Banana Bonanza Quesadillas with Raspberry Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter757#C7-57"
    }
  }, [_vm._v("Moist Oatmeal Cranberry Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter758#C7-58"
    }
  }, [_vm._v("Balsamic Strawberry Yogurt Pops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Appendix#AP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: "), _c('b', [_vm._v("Resources")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb868e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0